import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as FronteggReduxStore from '@frontegg/redux-store';
import { createStore, DEFAULT_RETRY_CONFIG, errorTraceId, getFeatureEntitlements as _getFeatureEntitlements, getPermissionEntitlements as _getPermissionEntitlements, isSteppedUp as _isSteppedUp, redirectByStepUpUrl, REQUEST_NAME, retryIfNeeded } from '@frontegg/redux-store';
import * as FronteggTypes from '@frontegg/types';
import { Metadata } from '@frontegg/types';
import { formatName, restoreSearchParams } from '../utils';
import { AppHolder } from '../AppHolder';
import * as FronteggRestApi from '@frontegg/rest-api';
import { ContextHolder, createApiClient, FetchClient, RequestSource } from '@frontegg/rest-api';
import versions from '../version';
import { mockFlagsList } from '../utils/mockFlagsList';
import { getOverriddenMetadata, loadGTM } from './utils';
export var FronteggApp = /*#__PURE__*/function () {
  function FronteggApp(_options, name) {
    var _this = this,
      _this$options$authOpt3,
      _options$authOptions;
    var iframeRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var allowMultipleRenderers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    _classCallCheck(this, FronteggApp);
    this.name = void 0;
    this.iframeRendering = void 0;
    this.options = void 0;
    this.loading = true;
    this.cdnUrl = "https://assets.frontegg.com/admin-box/".concat(versions.cdnVersion);
    this.assetsUrl = "https://adminBox.frontegg.com/admin-box/".concat(versions.cdnVersion);
    this.customElementName = '';
    this.adminPortalEl = void 0;
    this.adminPortalRenderer = void 0;
    this.loginBoxEl = void 0;
    this.checkoutDialogEl = void 0;
    this.checkoutDialogRenderer = void 0;
    this.adminPortalContainer = void 0;
    this.loginBoxContainer = void 0;
    this.checkoutDialogContainer = void 0;
    this.loginBoxRenderer = void 0;
    this.store = void 0;
    this.loadingListeners = [];
    this.fetchClient = void 0;
    this.apiClient = void 0;
    this.updateLocalizations = void 0;
    this.loadAdminBoxMetadata = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _data$rows$0$configur, _data$rows, _data$rows$, data, metadata;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.options.metadata) {
              _context.next = 21;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return retryIfNeeded(function () {
              return _this.fetchClient.get('/metadata', {
                entityName: 'adminBox'
              });
            }, DEFAULT_RETRY_CONFIG);
          case 4:
            data = _context.sent;
            metadata = (_data$rows$0$configur = data == null ? void 0 : (_data$rows = data.rows) == null ? void 0 : (_data$rows$ = _data$rows[0]) == null ? void 0 : _data$rows$.configuration) != null ? _data$rows$0$configur : {};
            _context.prev = 6;
            _context.next = 9;
            return getOverriddenMetadata(metadata, _this.fetchClient, DEFAULT_RETRY_CONFIG);
          case 9:
            _this.options.metadata = _context.sent;
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](6);
            console.error('failed to get admin portal overridden metadata', _context.t0);
          case 15:
            _context.next = 21;
            break;
          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](1);
            console.error('failed to get admin portal metadata', _context.t1);
            _this.dispatchErrorByRequestName(_context.t1, REQUEST_NAME.LOAD_ADMIN_BOX_METADATA);
          case 21:
            Metadata.set(_this.options.metadata, _this.name);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 17], [6, 12]]);
    }));
    this.requestAuthorize = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$options$authOpt, _this$options$authOpt2;
      var shouldRequestHostedLoginAuthorize;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            shouldRequestHostedLoginAuthorize = (_this$options$authOpt = _this.options.authOptions) == null ? void 0 : (_this$options$authOpt2 = _this$options$authOpt.hostedLoginOptions) == null ? void 0 : _this$options$authOpt2.loadUserOnFirstLoad;
            if (!_this.options.builderMode && _this.options.framework !== 'nextjs') {
              if (_this.options.hostedLoginBox && !_this.options.customLoginBox) {
                if (shouldRequestHostedLoginAuthorize) {
                  _this.store.dispatch({
                    type: 'auth/requestHostedLoginAuthorizeV2',
                    payload: {
                      shouldRedirectToLogin: false,
                      firstTime: true
                    }
                  });
                }
              } else {
                _this.store.dispatch({
                  type: 'auth/requestAuthorize',
                  payload: true
                });
              }
            }
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    this.loadFeatureFlags = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var flags;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(_this.options.previewMode || _this.options.builderMode)) {
              _context3.next = 4;
              break;
            }
            FronteggRestApi.FeatureFlags.set(mockFlagsList, _this.name);
            _context3.next = 16;
            break;
          case 4:
            _context3.prev = 4;
            _context3.next = 7;
            return retryIfNeeded(function () {
              return _this.apiClient.featureFlags.loadFeatureFlags();
            }, DEFAULT_RETRY_CONFIG);
          case 7:
            flags = _context3.sent;
            if (_this.options.overrideFeatureFlags) {
              Object.assign(flags, _this.options.overrideFeatureFlags);
            }
            FronteggRestApi.FeatureFlags.set(flags, _this.name);
            _context3.next = 16;
            break;
          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](4);
            console.error('failed to get admin portal feature flags', _context3.t0);
            _this.dispatchErrorByRequestName(_context3.t0, REQUEST_NAME.LOAD_FEATURE_FLAGS);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[4, 12]]);
    }));
    this.setFeatureFlagsForPreview = function (previewFeatureFlags) {
      FronteggRestApi.FeatureFlags.set(Object.assign({}, mockFlagsList, previewFeatureFlags), _this.name);
    };
    this.queryFeatureFlags = function (flags) {
      return FronteggRestApi.FeatureFlags.getFeatureFlags(flags, _this.name);
    };
    this.updateLocalizationsSetter = function (localizationUpdateFn) {
      _this.updateLocalizations = localizationUpdateFn;
    };
    this.getEntitlementsFromStore = function () {
      var _this$store$getState$;
      return (_this$store$getState$ = _this.store.getState().auth.user) == null ? void 0 : _this$store$getState$.entitlements;
    };
    this.getUserFromStore = function () {
      return _this.store.getState().auth.user;
    };
    this.getEntitlementsQueryData = function (customAttributes) {
      var user = _this.getUserFromStore();
      var entitlements = _this.getEntitlementsFromStore();
      var attributes = {
        custom: customAttributes,
        jwt: user
      };
      return {
        entitlements: entitlements,
        attributes: attributes
      };
    };
    var appName = formatName(name);
    var customElementName = "frontegg-app-".concat(appName);
    this.iframeRendering = iframeRendering;
    this.name = appName;
    this.options = Object.assign({}, _options, {
      contextOptions: Object.assign({
        requestCredentials: 'include'
      }, _options.contextOptions)
    });
    this.fetchClient = new FetchClient(this.name);
    this.apiClient = createApiClient(this.name);
    if (this.options.cdnUrl) {
      this.cdnUrl = this.options.cdnUrl;
    }
    if (this.options.assetsUrl) {
      this.assetsUrl = this.options.assetsUrl;
    }
    ContextHolder["for"](this.name).setCdnUrl(this.cdnUrl);
    ContextHolder["for"](this.name).setAssetsUrl(this.assetsUrl);
    this.customElementName = customElementName;
    var authOptions = this.options.authOptions ? Object.assign({}, this.options.authOptions, {
      hostedLoginBox: this.options.hostedLoginBox
    }) : {
      hostedLoginBox: this.options.hostedLoginBox
    };
    authOptions.onRedirectTo = _options.onRedirectTo;
    authOptions.disableSilentRefresh = (_this$options$authOpt3 = this.options.authOptions) == null ? void 0 : _this$options$authOpt3.disableSilentRefresh;
    if (this.options.store) {
      this.store = this.options.store;
      if (!allowMultipleRenderers && this.options.store.getState().root.appName !== name) {
        throw Error('Mismatch in store names');
      }
    } else {
      var _this$options$authOpt4, _this$options$auditsO;
      this.store = createStore({
        context: this.options.contextOptions,
        name: this.name,
        builderMode: this.options.builderMode,
        previewMode: this.options.previewMode,
        storeHolder: this,
        urlStrategy: this.options.urlStrategy,
        initialState: {
          auth: Object.assign({}, authOptions, (_this$options$authOpt4 = this.options.authOptions) != null ? _this$options$authOpt4 : {}),
          auditLogs: Object.assign({}, (_this$options$auditsO = this.options.auditsOptions) != null ? _this$options$auditsO : {})
        }
      });
    }
    AppHolder.setInstance(appName, this);
    var contextHolder = ContextHolder["for"](appName);
    contextHolder.setAppName(appName);
    this.setEntitlementsOptions(_options.entitlementsOptions);
    this.setSessionContext({
      enableSessionPerTenant: (_options$authOptions = _options.authOptions) == null ? void 0 : _options$authOptions.enableSessionPerTenant
    });

    // pay attention: basename is used from the router base name, then if it's empty it will be the frontegg options basename
    var basename = _options.basename;
    if (basename) {
      contextHolder.setBasename(basename);
    }
  }

  /**
   * Set entitlements related options in context holder according to frontegg options
   * @param entitlementsOptions - entitlements options from frontegg options
   */
  _createClass(FronteggApp, [{
    key: "setEntitlementsOptions",
    value: function setEntitlementsOptions(entitlementsOptions) {
      ContextHolder["for"](this.name).setEntitlementsOptions(Object.assign({}, entitlementsOptions));
    }
  }, {
    key: "setSessionContext",
    value: function setSessionContext(sessionContext) {
      ContextHolder["for"](this.name).setSessionContext(Object.assign({}, sessionContext));
    }
  }, {
    key: "dispatchErrorByRequestName",
    value: function dispatchErrorByRequestName(error, requestName) {
      if ((error == null ? void 0 : error.statusCode) < 500) return;
      this.store.dispatch({
        type: 'auth/setErrorByRequestName',
        payload: {
          requestName: requestName,
          traceId: errorTraceId(error)
        }
      });
    }
  }, {
    key: "initContainers",
    value: function () {
      var _initContainers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(elements) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.adminPortalEl = elements.adminPortalEl;
              this.loginBoxEl = elements.loginBoxEl;
              this.checkoutDialogEl = elements.checkoutDialogEl;
              this.adminPortalContainer = elements.adminPortalContainer;
              this.loginBoxContainer = elements.loginBoxContainer;
              this.checkoutDialogContainer = elements.checkoutDialogContainer;
              try {
                if (this.options.framework !== 'nextjs') {
                  document.body.classList.add('frontegg-loading');
                }
              } catch (e) {
                console.error('Failed to add frontegg-loading to body classList');
              }

              // feature flags loading should be called before requestAuthorize because it uses ff
              _context4.next = 9;
              return this.loadFeatureFlags();
            case 9:
              _context4.next = 11;
              return Promise.all([this.loadAdminBoxMetadata(), this.requestAuthorize()]);
            case 11:
              if (!this.options.previewMode && !this.options.customLoginBox) {
                this.loadLoginBox();
                loadGTM(this.name);
              }
              if (!this.options.lazyLoadAdminPortal) {
                this.loadScript('FronteggAdminPortal');
              }
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function initContainers(_x) {
        return _initContainers.apply(this, arguments);
      }
      return initContainers;
    }()
  }, {
    key: "updateMetadata",
    value: function updateMetadata(metadata) {
      Metadata.set(metadata, this.name);
      if (metadata != null && metadata.localizations) {
        var _this$updateLocalizat;
        (_this$updateLocalizat = this.updateLocalizations) == null ? void 0 : _this$updateLocalizat.call(this, metadata.localizations);
      }
    }
  }, {
    key: "addOnLoadedListener",
    value: function addOnLoadedListener(listener) {
      if (!this.loading) {
        listener();
        return;
      }
      this.loadingListeners.push(listener);
    }
  }, {
    key: "ready",
    value: function ready(listener) {
      if (this.loading) {
        listener();
      } else {
        this.addOnLoadedListener(listener);
      }
    }
  }, {
    key: "loginWithRedirect",
    value: function loginWithRedirect() {
      var additionalParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.store.dispatch({
        type: 'auth/setState',
        payload: {
          isLoading: true
        }
      });
      this.store.dispatch({
        type: 'auth/requestHostedLoginAuthorize',
        payload: additionalParams
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      this.store.dispatch({
        type: 'auth/setState',
        payload: {
          isLoading: true
        }
      });
      this.store.dispatch({
        type: 'auth/logout'
      });
    }
  }, {
    key: "loadScript",
    value: function loadScript(component) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        // TODO: prevent this behavior if development
        var scriptHolder = window;
        if (scriptHolder[component]) {
          resolve(scriptHolder[component]);
          return;
        }

        

        var entries = {
          FronteggLoginBox: 'login-box/index.js',
          FronteggAdminPortal: 'admin-portal/index.js'
        };
        var script = document.createElement('script');
        script.src = "".concat(_this2.cdnUrl, "/").concat(entries[component]);
        script.setAttribute('id', "".concat(component, "Script"));
        script.setAttribute('cdn-url', _this2.cdnUrl);
        script.onload = function () {
          if (scriptHolder["".concat(component, "Init")]) {
            resolve(scriptHolder["".concat(component, "Init")]({
              FronteggRestApi: FronteggRestApi,
              FronteggTypes: FronteggTypes,
              FronteggReduxStore: FronteggReduxStore
            }));
          } else {
            resolve(scriptHolder[component]);
          }
        };
        script.onerror = function (e) {
          // eslint-disable-next-line no-console
          console.log('Profile page error', e);
          reject(e);
        };
        document.body.append(script);
      });
    }
  }, {
    key: "loadLoginBox",
    value: function () {
      var _loadLoginBox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var FronteggLoginBox;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.loadScript('FronteggLoginBox');
            case 2:
              FronteggLoginBox = _context5.sent;
              FronteggLoginBox.render(this.loginBoxEl, {
                injector: this,
                options: this.options
              });
              this.loading = false;
              this.loadingListeners.forEach(function (listener) {
                try {
                  listener();
                } catch (e) {
                  console.error('Failed to call loadLoginBoxListener', e);
                }
              });
              this.loadingListeners = [];
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function loadLoginBox() {
        return _loadLoginBox.apply(this, arguments);
      }
      return loadLoginBox;
    }()
  }, {
    key: "showAdminPortal",
    value: function () {
      var _showAdminPortal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(options) {
        var _ref4, isMultiApp, _this$queryFeatureFla, _this$queryFeatureFla2, multiAppsFlag, FronteggAdminPortal;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref4 = options != null ? options : {
                isMultiApp: false
              }, isMultiApp = _ref4.isMultiApp;
              _this$queryFeatureFla = this.queryFeatureFlags(['multi-apps-admin-portal']), _this$queryFeatureFla2 = _slicedToArray(_this$queryFeatureFla, 1), multiAppsFlag = _this$queryFeatureFla2[0];
              ContextHolder["for"](this.name).setRequestSource(RequestSource.AdminPortal);
              _context6.next = 5;
              return this.loadScript('FronteggAdminPortal');
            case 5:
              FronteggAdminPortal = _context6.sent;
              this.adminPortalRenderer = FronteggAdminPortal.render(this.adminPortalEl, {
                injector: this,
                options: Object.assign({
                  isMultiApp: multiAppsFlag && isMultiApp
                }, this.options)
              });
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function showAdminPortal(_x2) {
        return _showAdminPortal.apply(this, arguments);
      }
      return showAdminPortal;
    }()
    /**
     * Open the hosted portal must be called synchronously with user interaction
     *
     * @param newTab - open the portal in a new tab = true
     */
  }, {
    key: "openHostedAdminPortal",
    value: function openHostedAdminPortal() {
      var newTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var baseUrl = this.options.contextOptions.baseUrl;
      var hostedPortalUrl = "".concat(baseUrl, "/oauth/portal");
      if (newTab) {
        window.open(hostedPortalUrl, '_blank');
        return;
      }
      window.location.href = hostedPortalUrl;
    }
  }, {
    key: "hideAdminPortal",
    value: function hideAdminPortal() {
      try {
        var _this$adminPortalRend;
        var searchParams = new URLSearchParams(window.location.search);
        (_this$adminPortalRend = this.adminPortalRenderer) == null ? void 0 : _this$adminPortalRend.unmount();
        // unmount is removing url search params, therefore we need to restore them after unmount
        restoreSearchParams(searchParams);
        ContextHolder["for"](this.name).setRequestSource(null);
      } catch (e) {
        console.error('Failed to unmount admin portal', e);
      }
    }
  }, {
    key: "showCheckoutDialog",
    value: function () {
      var _showCheckoutDialog = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(opts) {
        var FronteggAdminPortal;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.loadScript('FronteggAdminPortal');
            case 2:
              FronteggAdminPortal = _context7.sent;
              this.checkoutDialogRenderer = FronteggAdminPortal.renderCheckoutDialog(this.checkoutDialogEl, Object.assign({
                injector: this
              }, opts, {
                options: this.options
              }));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function showCheckoutDialog(_x3) {
        return _showCheckoutDialog.apply(this, arguments);
      }
      return showCheckoutDialog;
    }()
  }, {
    key: "hideCheckoutDialog",
    value: function hideCheckoutDialog() {
      try {
        var _this$checkoutDialogR;
        (_this$checkoutDialogR = this.checkoutDialogRenderer) == null ? void 0 : _this$checkoutDialogR.unmount();
      } catch (e) {
        console.error('Failed to unmount checkout dialog', e);
      }
    }

    /**
     * @returns entitlements store data
     */
  }, {
    key: "getFeatureEntitlements",
    value:
    /**
      @param key feature key
      @param customAttributes user attributes
      @returns if the user is entitled to the given feature. Attaching the justification if not
      @throws when entitlement is not enabled via frontegg options
    */
    function getFeatureEntitlements(key, customAttributes) {
      var _this$getEntitlements = this.getEntitlementsQueryData(customAttributes),
        entitlements = _this$getEntitlements.entitlements,
        attributes = _this$getEntitlements.attributes;
      return _getFeatureEntitlements(entitlements, key, attributes);
    }

    /**
      @param key permission key
      @param customAttributes user attributes
      @returns if the user is entitled to the given permission. Attaching the justification if not
      @throws when entitlement is not enabled via frontegg options
    */
  }, {
    key: "getPermissionEntitlements",
    value: function getPermissionEntitlements(key, customAttributes) {
      var _this$getEntitlements2 = this.getEntitlementsQueryData(customAttributes),
        entitlements = _this$getEntitlements2.entitlements,
        attributes = _this$getEntitlements2.attributes;
      return _getPermissionEntitlements(entitlements, key, attributes);
    }

    /**
      @param options - including permission or feature key
      @param customAttributes user attributes
      @returns if the user is entitled to the given permission or feature. Attaching the justification if not
      @throws when entitlement is not enabled via frontegg options
    */
  }, {
    key: "getEntitlements",
    value: function getEntitlements(options, customAttributes) {
      // we use permissionKey (options key) to decide if the user is using permission key or feature key
      if ('permissionKey' in options) {
        return this.getPermissionEntitlements(options.permissionKey, customAttributes);
      }
      return this.getFeatureEntitlements(options.featureKey, customAttributes);
    }

    /**
     * Load entitlements
     * @param callback called on request completed with true if succeeded, false if failed
     */
  }, {
    key: "loadEntitlements",
    value: function loadEntitlements(callback) {
      this.store.dispatch({
        type: 'auth/loadEntitlements',
        payload: {
          callback: callback
        }
      });
    }

    /**
     * Redirects to the step up page with the max age param and set the redirect url in the local storage
     * @param options.maxAge optional max age
     */
  }, {
    key: "stepUp",
    value: function stepUp(options) {
      var state = this.store.getState();
      var _ref5 = (state == null ? void 0 : state.auth) || {},
        hostedLoginBox = _ref5.hostedLoginBox,
        stepUpUrl = _ref5.routes.stepUpUrl;
      if (hostedLoginBox) {
        this.store.dispatch({
          type: 'auth/stepUpHostedLogin',
          payload: options
        });
        return;
      }
      redirectByStepUpUrl(stepUpUrl, state.auth.onRedirectTo, options == null ? void 0 : options.maxAge);
    }

    /**
     * @param options.maxAge optional max age
     * @return true when user is stepped up, false otherwise
     */
  }, {
    key: "isSteppedUp",
    value: function isSteppedUp() {
      var _this$store$getState;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref6 = ((_this$store$getState = this.store.getState()) == null ? void 0 : _this$store$getState.auth) || {},
        user = _ref6.user;
      return _isSteppedUp(user, options);
    }

    /**
     * Switch tenant
     * @param payload.tenantId tenant id to switch for
     * @param payload.callback optional callback to be called with true / false for success / failure tenant switching operation
     */
  }, {
    key: "switchTenant",
    value: function switchTenant(payload) {
      this.store.dispatch({
        type: 'auth/switchTenant',
        payload: payload
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.hideAdminPortal();
      this.hideCheckoutDialog();
    }
  }]);
  return FronteggApp;
}();